var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavMyCreations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_1293_13500"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 16,
    height: 16,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_1293_13500)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.9369,3.93238C4.9369,1.76057,6.75615,0,8.9998,0C11.24344,0,13.0627,1.76057,13.0627,3.93238C13.0627,6.10418,11.24344,7.86484,8.9998,7.86484C6.75615,7.86484,4.9369,6.10418,4.9369,3.93238ZM8.9998,1.573C7.65361,1.573,6.5629,2.62929,6.5629,3.93238C6.5629,5.23546,7.65361,6.29183,8.9998,6.29183C10.34599,6.29183,11.4381,5.23546,11.4381,3.93238C11.4381,2.62929,10.34599,1.573,8.9998,1.573ZM2.5,12.8541C2.5,10.6823,4.31885,8.92166,6.5625,8.92166L11.4375,8.92166C13.6811,8.92166,15.5,10.6823,15.5,12.8541L15.5,15.2135C15.5,15.6479,15.1362,16,14.6875,16C14.6176,16,14.5499,15.9915,14.4852,15.9754L14.4852,15.9816L3.51642,15.9816L3.51642,15.975C3.451257,15.9913,3.382925,16,3.3125,16C2.863768,16,2.5,15.6479,2.5,15.2135L2.5,12.8541ZM4.125,14.5659L13.875,14.5659L13.875,12.8541C13.875,11.5509,12.7837,10.4946,11.4375,10.4946L6.5625,10.4946C5.21631,10.4946,4.125,11.5509,4.125,12.8541L4.125,14.5659Z",
    fillRule: "evenodd",
    fillOpacity: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavMyCreations);
export default __webpack_public_path__ + "static/media/nav_my_creations.f005ad62e5c1f81e136347802057f94d.svg";
export { ForwardRef as ReactComponent };